<div class="form-group row">
  <div [class]="label_class + ' text-sm-end'">
    <label [attr.for]="control_id" class="col-form-label">{{ row_label }}</label>
    <small *ngIf="row_sub_label"><br/>{{ row_sub_label }}</small>
  </div>
  <div [class]="value_class">
    <ng-content></ng-content>
  </div>
</div>